import { Button, Modal, Tag } from 'antd';
import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';

const ModalComponent = ({ text, isComment }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="row">
      <Button type="primary" onClick={showModal}>
        Show
      </Button>
      <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={1000}>
        {isComment ? (
          <>
            {text?.map((item: any) => {
              return (
                <>
                  <div className="row">
                    <div className="col-sm-12 mb-1">
                      <div style={{ background: 'pink', padding: '5px', borderRadius: '5px' }}>{item?.body}</div>
                    </div>

                    {item?.replies?.map((value: any) => {
                      return (
                        <div className="col-sm-12 mb-1">
                          <div style={{ background: 'gray', padding: '5px', borderRadius: '5px', color: 'white' }}>
                            {value}
                          </div>
                        </div>
                      );
                    })}

                    <div className="col-sm-12">
                      <hr />
                    </div>
                  </div>
                </>
              );
            })}
          </>
        ) : (
          <ReactMarkdown>{text}</ReactMarkdown>
        )}
      </Modal>
    </div>
  );
};

export default ModalComponent;
